module.exports = __webpack_public_path__ + "static/img/register.12cdaf08.png";